import { GA } from '../../../feature/google-analytics/ga';
import type { Dealer } from '../dealer.types';

export const useGtmTracking = () => {
  const trackPromotion = (dealer?: Dealer, promotion_click_type = 'detail', creative_name = 'detail', creative_slot = '1') => {
    if (!dealer) {
      return;
    }

    GA.sendRawEvent({
      event: 'ec.select_promotion',
      event_name: 'select_promotion',
      select_promotion: {
        promotion_click_type,
      },
      ecommerce: {
        items: [
          {
            promotion_id: dealer.id,
            promotion_name: `${dealer.description} || ${dealer.location.postalCode} ${dealer.location.locality} ${dealer.location.country}`,
            creative_name,
            creative_slot,
          },
        ],
      },
    });
  };

  const trackDealerClick = (dealer?: Dealer, clickType = 'show-details') => {
    if (!dealer) {
      return;
    }
    GA.sendRawEvent({
      event: 'ec.select_promotion',
      event_name: 'select_promotion',
      select_promotion: {
        promotion_click_type: 'show-details',
      },
      ecommerce: {
        items: [
          {
            promotion_id: dealer.id,
            promotion_name: `${dealer.description} || ${dealer.location.postalCode} ${dealer.location.locality} ${dealer.location.country}`,
            creative_name: clickType,
            creative_slot: '1',
          },
        ],
      },
    });
  };

  const trackDealerSearch = (searchTerm: string) => {
    GA.sendRawEvent({
      event: 'page_load',
      pagePath: `/dealer?dealer-search=${encodeURIComponent(searchTerm)}`,
    });

    GA.sendRawEvent({
      event_name: 'dealer_search',
      dealer_search: {
        search_term: searchTerm,
        search_category: 'dealer_search',
      },
    });
  };

  const trackPageLoad = (pagePath: string) => {
    GA.sendRawEvent({
      event: 'page_load',
      pagePath,
    });
  };

  const trackDealerImpressions = (dealers: Dealer[]) => {
    GA.sendRawEvent({
      event: 'ec.view_promotion',
      event_name: 'view_promotion',
      ecommerce: {
        items: dealers.map((dealer, index) => ({
          promotion_id: dealer.id,
          promotion_name: `${dealer.description} || ${dealer.location.postalCode} ${dealer.location.locality} ${dealer.location.country}`,
          creative_name: 'map',
          creative_slot: (index + 1).toString(),
        })),
      },
    });
  };

  return {
    trackPromotion,
    trackDealerSearch,
    trackPageLoad,
    trackDealerImpressions,
    trackDealerClick,
  };
};
